var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bl-toolbar-item"},[_vm._t("default",null,{anchorTop:null,anchorRight:null,anchorBottom:null,anchorLeft:null}),(_vm.showLabel)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }